import { DOIInfo } from './DOIInfo';
import { DOIInfoInstrument } from './DOIInfoInstrument';
import { DOINotFound } from './DOINotFound';
import { convertDataciteToInternal } from './utils/convert';
import { type DataciteDOI } from './utils/datacite';
import { endpoint, useLocalGetEndpoint } from './utils/fetching';

const DATACITE_GET_DOI = endpoint({
  server: 'DATACITE',
  path: 'dois/:doi',
  params: {} as { doi: string },
  schema: {} as DataciteDOI,
});

export function FetchDOIFromDatacite({
  doi,
  isInstrument,
}: {
  doi: string;
  isInstrument: boolean;
}) {
  const dataciteDOI = useLocalGetEndpoint({
    endpoint: DATACITE_GET_DOI,
    params: { doi },
  });

  // `useLocalGetEndpoint` returns undefined data in case of error reponse (like 404)
  if (!dataciteDOI) {
    return <DOINotFound />;
  }

  const internalDOI = convertDataciteToInternal(dataciteDOI.data.attributes);

  return isInstrument ? (
    <DOIInfoInstrument doi={internalDOI} />
  ) : (
    <DOIInfo doi={internalDOI} />
  );
}
